// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `i {
    position: relative;
    display: inline-block;
    font-size: 2.5rem;
    padding-right: 0.1rem;
    color: #d3d3d3;
}

.filled {
    color: #ffa600;
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
}

::ng-deep app-rating .visually-hidden{
    display: none;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInJhdGluZy5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0ksa0JBQWtCO0lBQ2xCLHFCQUFxQjtJQUNyQixpQkFBaUI7SUFDakIscUJBQXFCO0lBQ3JCLGNBQWM7QUFDbEI7O0FBRUE7SUFDSSxjQUFjO0lBQ2QsZ0JBQWdCO0lBQ2hCLGtCQUFrQjtJQUNsQixNQUFNO0lBQ04sT0FBTztBQUNYOztBQUVBO0lBQ0ksYUFBYTtBQUNqQiIsImZpbGUiOiJyYXRpbmcuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbImkge1xuICAgIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgICBkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG4gICAgZm9udC1zaXplOiAyLjVyZW07XG4gICAgcGFkZGluZy1yaWdodDogMC4xcmVtO1xuICAgIGNvbG9yOiAjZDNkM2QzO1xufVxuXG4uZmlsbGVkIHtcbiAgICBjb2xvcjogI2ZmYTYwMDtcbiAgICBvdmVyZmxvdzogaGlkZGVuO1xuICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICB0b3A6IDA7XG4gICAgbGVmdDogMDtcbn1cblxuOjpuZy1kZWVwIGFwcC1yYXRpbmcgLnZpc3VhbGx5LWhpZGRlbntcbiAgICBkaXNwbGF5OiBub25lO1xufSJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/shared/rating/rating.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;;AAEA;IACI,aAAa;AACjB;AACA,g1BAAg1B","sourcesContent":["i {\n    position: relative;\n    display: inline-block;\n    font-size: 2.5rem;\n    padding-right: 0.1rem;\n    color: #d3d3d3;\n}\n\n.filled {\n    color: #ffa600;\n    overflow: hidden;\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n\n::ng-deep app-rating .visually-hidden{\n    display: none;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
